<template>
    <div>
        <div v-if="userType === 1" class="rank">
            <div v-if="(coin > 0)">
                第<span>{{ rank }}</span>名
            </div>
            <div v-else-if="(winnerCoin > 0)">进步奖</div>
        </div>
        <div v-else class="no-rank">{{ text }}</div>
    </div>

</template>
<script>
export default {
    props: {
        rank: {
            default: null
        },
        userType: {
            default: null
        },
        winnerCoin: {
            default: 0
        },
        coin: {
            type: Number,
            default: 0
        }
    },
    // watch: {
    //     userType(val) {
    //         console.log(val, '124s')
    //         if (val === 2) {
    //             this.text = "很遗憾"
    //         }
    //         if (val === 3) {
    //             this.text = "未出勤"
    //         }

    //     }
    // },
    data() {
        return {
            text: ''
        }
    },
    mounted() {
        if (this.userType === 2) {
            this.text = "很遗憾"
        }
        if (this.userType === 3) {
            this.text = "未出勤"
        }

    },
}
</script>
<style scoped lang="stylus">
@import url("./index.styl")
</style>